import { Component, OnDestroy, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AvailableLookupOsUpdate, InstallAction, MdmCommandService, RequestType } from '@rocksoft/mdm-sdk-v2';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ml-install-lookup-os-update-modal',
  templateUrl: './install-lookup-os-update-modal.component.html',
  imports: [ReactiveFormsModule, FormsModule, FaIconComponent],
})
export class InstallLookupOsUpdateModalComponent implements OnDestroy {
  private readonly commandService = inject(MdmCommandService);
  public readonly modal = inject(NgbActiveModal);

  public udid: string;
  public update: AvailableLookupOsUpdate;

  public installAction: InstallAction;
  subscription: Subscription | undefined;
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
  }

  public installUpdate(): void {
    this.subscription = this.commandService
      .queueScheduleOSUpdateCommand({
        udid: this.udid,
        apiVersion: '2.0',
        scheduleOSUpdateCommand: {
          requestType: RequestType.ScheduleOsUpdate,
          updates: [
            {
              productVersion: this.update.productVersion,
              installAction: this.installAction,
            },
          ],
        },
      })
      .subscribe(() => {
        this.modal.dismiss();
      });
  }
}
